import { hexToRgb } from 'codekit';

import { Theme } from 'styles/themes';

const toRgb = (color: string) => hexToRgb(color).join(', ');

export function parseThemeToStyle(theme: Theme) {
	const style = Object.entries(theme.colors).reduce(
		(acc, [key, value]) => {
			const isHex = value.startsWith('#') && value.length >= 7;

			acc[`--color-${key}`] = value;

			if (isHex) {
				acc[`--color-${key}-rgb`] = toRgb(value);
			}

			return acc;
		},
		{} as Record<string, string>,
	);

	return style as React.CSSProperties;
}
